import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import ReputationChart from 'common/components/reputation_chart';
import ReputationTag from 'common/components/reputation_tag';
import Avatar from 'common/components/avatar';

const EmptyResults = () => (
  <div className="small-16 column">
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <h3>No participants</h3>
      </div>
    </div>
  </div>
);

export const TableRow = ({
  id, avatar, first_name, last_name, username, reputation,
  is_elite, is_platinum
}) => {
  const reputationInt = parseInt(reputation, 10);

  return (<tr>
    <td>
      <Link to={`/users/${username}/`} target="_blank">
        <Avatar user={{ avatar, first_name, last_name, username }}
          extraClasses="avatar-sm avatar-inline show-for-medium"/> {username}
      </Link>
    </td>
    <td>
      <ReputationChart className="stat-chart" reputation={reputationInt} chartClass="small"/>
      <ReputationTag user={{ is_elite, is_platinum }} />
    </td>
  </tr>);
};

export default class ParticipantsTable extends Component {
  render() {
    const { items } = this.props;
    if (!items.length) {
      return (<EmptyResults />);
    }

    return (
      <div className="small-16 column">
        <table className="table table-default access participants">
          <thead>
            <tr>
              <td>user</td>
              <td>reputation</td>
            </tr>
          </thead>
          <tbody>
            { items.map(item => <TableRow key={item.id} {...item} />) }
          </tbody>
        </table>
      </div>
    );
  }
}

ParticipantsTable.propTypes = {
  items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/participants.jsx